import { Button } from "@/components/buttons/button/button";
import styles from "./page-footer.module.scss";

export interface FooterButtonConfig {
  text: string;
  onClick: () => void;
  loading?: boolean;
  disabled?: boolean;
}

export interface PageFooterProps {
  primaryButton: FooterButtonConfig;
  secondaryButton?: FooterButtonConfig;
}

export function PageFooter({
  primaryButton,
  secondaryButton,
}: PageFooterProps) {
  return (
    <div className={styles.footerContainer}>
      {secondaryButton && (
        <Button
          type="button"
          onClick={secondaryButton.onClick}
          variant="secondary"
          size="small"
          loading={secondaryButton.loading}
          disabled={secondaryButton.disabled || secondaryButton.loading}
        >
          {secondaryButton.text}
        </Button>
      )}
      <Button
        type="button"
        onClick={primaryButton.onClick}
        variant="primary"
        size="small"
        loading={primaryButton.loading}
        disabled={primaryButton.disabled || primaryButton.loading}
      >
        {primaryButton.text}
      </Button>
    </div>
  );
}
